
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Component({})
    export default class ReportBar extends Vue {

        @Prop({ default: "" })
        text1!: string;

        @Prop({ default: "" })
        text2!: string;

        @Prop({ required: true })
        percentValue1!: number;

        @Prop({ default: 0 })
        percentValue2!: number;
        
        get percent1WidthStyle(): Record<string, string> {
            const percent = this.percentValue1 > 100 ? 100 : this.percentValue1;
            return { "flexBasis": `${percent}%` };
        }

        get percent2WidthStyle(): Record<string, string> {
            const percent = (this.percentValue1 + this.percentValue2) > 100 ? 0 : this.percentValue2;
            return { "flexBasis": `${percent}%` };
        }
    }
